import { ServicesComponent } from './services/services.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
// import { DetailsComponent } from './details/details.component';
import { RuleComponent } from './rule/rule.component';
import {AccountComponent} from './account/account.component';
import {DashComponent} from './dash/dash.component';
import { CommunityComponent } from './community/community.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { SupportComponent } from './support/support.component';

import {GmapComponent} from './gmap/gmap.component';
import {SoonComponent} from './soon/soon.component';
import { GatewayComponent } from './gateway/gateway.component';
import { ConstComponent } from './const/const.component';
import { LocationComponent } from './location/location.component';
import { EditScheComponent } from './edit-sche/edit-sche.component';
import { GeofencingComponent } from './geofencing/geofencing.component';
import { GeofenceAddComponent } from './geofence-add/geofence-add.component';
import { GeofencingViewComponent } from './geofencing-view/geofencing-view.component';

import { GeofencingView2Component } from './geofencing-view2/geofencing-view2.component';
import { DeviceEditComponent } from './dashboard/device-edit/device-edit.component';
import { ResetpwdComponent } from './resetpwd/resetpwd.component';
import { GetdevdetailComponent } from './const/getdevdetail/getdevdetail.component';
import { MyaccountComponent } from './myaccount/myaccount.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {DialogContentExampleDialogComponent} from './dialog-content-example-dialog/dialog-content-example-dialog.component';
import { DeviceShareComponent } from './dashboard/device-share/device-share.component';
import { ShareUserComponent } from './dashboard/share-user/share-user.component';
import { SpeednotifyComponent } from './dashboard/speednotify/speednotify.component';
import { ShareLocComponent } from './location/share-loc/share-loc.component';
import { AddComponent } from './add/add.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { NotificationComponent } from './notification/notification.component';
import { AddCustComponent } from './add-cust/add-cust.component';
import { SpecDevComponent } from './spec-dev/spec-dev.component';
import { GroupComponent } from './group/group.component';
import { AddGroupComponent } from './add-group/add-group.component';
import { EditGroupComponent } from './edit-group/edit-group.component';
import { DeleteGroupComponent } from './delete-group/delete-group.component';

import { SidemenuFuelComponent } from './sidemenu-fuel/sidemenu-fuel.component';
import { VehicleRouteComponent } from './vehicle-route/vehicle-route.component';
import { RouteSetComponent } from './route-set/route-set.component';
import { ShowRouteComponent } from './show-route/show-route.component';
import { DealersInfoComponent } from './dealers-info/dealers-info.component';
import { RouteMappingComponent } from './route-mapping/route-mapping.component';
import { RouteMapAddComponent } from './route-map-add/route-map-add.component';
import { PointOfIntrestComponent } from './point-of-intrest/point-of-intrest.component';
import { RouteDeleteComponent } from './route-delete/route-delete.component';
import { AddDealerComponent } from './add-dealer/add-dealer.component';
import { NotificationMasterComponent } from './notification-master/notification-master.component';
import { EditCostumerComponent } from './edit-costumer/edit-costumer.component';
import { EditDealerComponent } from './edit-dealer/edit-dealer.component';
import { TripHistoryComponent } from './trip-history/trip-history.component';
import { PoiListComponent } from './poi-list/poi-list.component';

import { ShowCaliberationComponent} from './show-caliberation/show-caliberation.component';
import {VehicleTypeComponent} from './vehicle-type/vehicle-type.component';
import { DriverDetailComponent } from './driver-detail/driver-detail.component';
import { DeviceModelComponent } from './device-model/device-model.component';
import { AddEditVehicleTypeComponent } from './add-edit-vehicle-type/add-edit-vehicle-type.component';
import { AddDriverComponent } from  './add-driver/add-driver.component';
import { AddDeviceModelComponent } from './add-device-model/add-device-model.component';
import { EditRouteMapComponent } from './edit-route-map/edit-route-map.component';
import { POIdetailsComponent } from './poidetails/poidetails.component';
import { PoiMenuComponent } from "./poi-menu/poi-menu.component";
import { LoadManagementComponent } from './load-management/load-management.component';
import { FuelReportGraphComponent } from './fuel-report-graph/fuel-report-graph.component';
import { EditVehicleTypeComponent } from './edit-vehicle-type/edit-vehicle-type.component';
import { UserMasterComponent } from './user-master/user-master.component'
import { DeviceComponent } from './device/device.component';
import { GpsMasterComponent } from './gps-master/gps-master.component';
import { CmdPacketMasterComponent } from './cmd-packet-master/cmd-packet-master.component';
import { POIreportComponent } from './poireport/poireport.component';
import { LRNumberComponent } from './lr-number/lr-number.component';
import { SOSAlertComponent } from './sosalert/sosalert.component';
import { HomeComponent } from './home/home.component';
import { EditDeviceModelComponent } from './edit-device-model/edit-device-model.component';
import { PoiMasterEditComponent } from './poi-master-edit/poi-master-edit.component';
import { NotificationSettingComponent } from './notification-setting/notification-setting.component';
import { LiveHistoryComponent } from './location/live-history/live-history.component';
import { DeviceEntryComponent } from './device-entry/device-entry.component';
import { InventoryListComponent } from './inventory-list/inventory-list.component';
import { GeneralSettingsComponent } from './dashboard/general-settings/general-settings.component';
import { DistributersListComponent } from './distributers-list/distributers-list.component';
import { AddDistributersComponent } from './add-distributers/add-distributers.component';
import { CostumerSupportComponent } from './costumer-support/costumer-support.component';
import { FuelObjectcomponentComponent } from './fuel-objectcomponent/fuel-objectcomponent.component';
import { ReportSettingComponent } from './add/report-setting/report-setting.component';
import { NormalCertComponent } from './device/normal-cert/normal-cert.component';
import { CertOptionComponent } from './device/cert-option/cert-option.component';

import { VehicleReminderComponent } from './vehicle-reminder/vehicle-reminder.component';

import { AddReminderComponent } from './vehicle-reminder/add-reminder/add-reminder.component';
import { ImmobilizeComponent } from './location/immobilize/immobilize.component';
import { ResetPasswordComponent } from './add/reset-password/reset-password.component';
import { DealerPermissionComponent } from './dealers-info/dealer-permission/dealer-permission.component';
import { DashboardContentComponent } from './add/dashboard-content/dashboard-content.component';
import { SharedDevicesComponent } from './const/shared-devices/shared-devices.component';
import { VehicleExpensesComponent } from './vehicle-expenses/vehicle-expenses.component';
import { AddVehicleExpensesComponent } from './vehicle-expenses/add-vehicle-expenses/add-vehicle-expenses.component';
import { VehicleExpenseDetailComponent } from './vehicle-expenses/vehicle-expense-detail/vehicle-expense-detail.component';
import { ProductSummaryComponent } from './product-summary/product-summary.component';
import { AddProductComponent } from './product-summary/add-product/add-product.component';
import { ProductShopComponent } from './product-shop/product-shop.component';
import { ProductOverviewComponent } from './product-shop/product-overview/product-overview.component';
import { PointShareComponent } from './point-share/point-share.component';
import { MessageUtilityComponent } from './message-utility/message-utility.component';
import { BuyNowComponent } from './product-shop/buy-now/buy-now.component';
import { BillingInfoComponent } from './product-shop/billing-info/billing-info.component';
import { OrderSummaryComponent } from './product-shop/order-summary/order-summary.component';
import { OrderDetailsComponent } from './product-shop/order-details/order-details.component';
import { DemoVideosComponent } from './const/demo-videos/demo-videos.component';
import { BillingDashboardComponent } from './billing-dashboard/billing-dashboard.component';
import { AccountDetailComponent } from './account-detail/account-detail.component';
import { CensorDisplayComponent } from './censor-display/censor-display.component';
import { ManualAddressComponent } from './const/manual-address/manual-address.component';
import { AddressUpdateComponent } from './address-update/address-update.component';
import { CmdUIComponent } from './location/cmd-ui/cmd-ui.component';
import { CommanQueueComponent } from './comman-queue/comman-queue.component';
import { CommandWindowComponent } from './location/command-window/command-window.component';
import { AddDeviceComponent } from './location/add-device/add-device.component';
import { SubAminComponent } from './sub-amin/sub-amin.component';
import { AddsubadminComponent } from './sub-amin/addsubadmin/addsubadmin.component';
import { PlayTripComponent } from './play-trip/play-trip.component';
import { DetailsComponent } from './details/details.component';
import { DisatanceReportComponent } from './report/report component/disatance-report/disatance-report.component';
import { MainComponent } from './report/main/main.component';
import { AcReportsComponent } from './report/report component/ac-report/ac-report.component';
import { DailyReportComponent } from './report/report component/daily-report/daily-report.component';
import { DailyLogssComponent } from './report/report component/daily-logs/daily-logs.component';
import { DayWiseReportComponent } from './report/report component/day-wise-report/day-wise-report.component';
import { GeofancingReportComponent } from './report/report component/geofancing-report/geofancing-report.component';
import { IdleReportComponent } from './report/report component/idle-report/idle-report.component';
import { IgnitionReportComponent } from './report/report component/ignition-report/ignition-report.component';
import { TripLoadUnloadComponent } from './report/report component/trip-load-unload/trip-load-unload.component';
import { OverSpeedComponent } from './report/report component/over-speed/over-speed.component';
import { POIReportComponent } from './report/report component/poi-report/poi-report.component';
import { RouteViolationComponent } from './report/report component/route-violation/route-violation.component';
import { DeviceSpeedReportComponent } from './report/report component/device-speed-report/device-speed-report.component';
import { SummaryReportComponent } from './report/report component/summary-report/summary-report.component';
import { StoppageReportComponent } from './report/report component/stoppage-report/stoppage-report.component';
import { DeviceSOSreportComponent } from './report/report component/device-sosreport/device-sosreport.component';
import { TripReportComponent } from './report/report component/trip-report/trip-report.component';
import { TravelPathReportComponent } from './report/report component/travel-path-report/travel-path-report.component';
import { WorkingHourReportComponent } from './report/report component/working-hour-report/working-hour-report.component';
import { MaintananceComponent } from './report/report component/maintanance/maintanance.component';
import { NotificationMastersComponent } from './report/report component/notification-master/notification-master.component';
import { DriversPerformanceReportComponent } from './report/report component/drivers-performance-report/drivers-performance-report.component';
import { DeviceRenewComponent } from './device-renew/device-renew.component';
import { ReportScheduleComponent } from './report-schedule/report-schedule.component';
import { DeviceFuelReportComponent } from './device-report/device-fuel-report/device-fuel-report.component';
import { NoReportComponent } from './report/report component/no-report/no-report.component';
import { StartComponent } from './report/report component/start/start.component';
import { TempretureReportComponent } from './device-report/tempreture-report/tempreture-report.component';
import { TempretureGraphComponent } from './device-report/tempreture-graph/tempreture-graph.component';
import { DeviceListComponent } from './device-list/device-list.component';
import { TollComponent } from './toll/toll.component';
import { NewTravelPathReportComponent } from './report/report component/new-travel-path-report/new-travel-path-report.component';
import { DeviceInventoryComponent } from './device-inventory/device-inventory.component';
import { IssueListComponent } from './issue-list/issue-list.component';
import { PushDataReportComponent } from './report/report component/push-data-report/push-data-report.component';
import { TechnicianComponent } from './technician/technician.component';
import { JobCardComponent } from './job-card/job-card.component';
import { AddJobCardComponent } from './job-card/add-job-card/add-job-card.component';
import { RechargeComponent } from './recharge/recharge.component';
import { RoutePlanComponent } from './route-plan/route-plan.component';
import { RoutPlanReportComponent } from './rout-plan-report/rout-plan-report.component';
import { RouteListComponent } from './route-plan/route-list/route-list.component';
import { InactiveAdminComponent } from './inactive-admin/inactive-admin.component';
import { UserFinderComponent } from './user-finder/user-finder.component';
import { ShowVehiclesComponent } from './show-vehicles/show-vehicles.component';
import { KycApprovalComponent } from './kyc-approval/kyc-approval.component';
import { FuelPriceComponent } from './fuel-price/fuel-price.component';
import { AddFuelPriceComponent } from './add-fuel-price/add-fuel-price.component';
import { RtoMasterComponent } from './rto-master/rto-master.component';
import { PerformanceReportComponent } from './report/report component/performance-report/performance-report.component';
import { LocationNewComponent } from './location/new-location/location.component';
// -----------------------------------------
// import { DriversPerformanceReportComponent } from './device-report/drivers-performance-report/drivers-performance-report.component';
// import { IdealReportComponent } from './device-report/ideal-report/ideal-report.component';
// import { DeviceSpeedReportComponent } from './device-report/device-speed-report/device-speed-report.component';
// import { IgnReportComponent } from './device-report/ign-report/ign-report.component';
// import { TripDetailsComponent } from './device-report/trip-details/trip-details.component';
// import { SummaryReportComponent } from './device-report/summary-report/summary-report.component';
// import { GeofancingReportComponent } from './device-report/geofancing-report/geofancing-report.component';
// import { OverSpeedComponent } from './device-report/over-speed/over-speed.component';
// import { RouteViolationComponent } from './device-report/route-violation/route-violation.component';
// import { StoppageReportComponent } from './device-report/stoppage-report/stoppage-report.component';
// import { IgnitionReportComponent } from './device-report/ignition-report/ignition-report.component';
// import { DistanceReportComponent } from './device-report/distance-report/distance-report.component';
// import { AlertReportComponent } from './device-report/alert-report/alert-report.component';
// import { TripReportComponent } from './device-report/trip-report/trip-report.component';
// import { POIReportComponent } from './device-report/poi-report/poi-report.component';
// import { DayWiseReportComponent } from './device-report/day-wise-report/day-wise-report.component';
// import { AcReportComponent } from './device-report/ac-report/ac-report.component';
// import { FuelReportComponent } from './device-report/fuel-report/fuel-report.component';
// import { DeviceFuelReportComponent } from './device-report/device-fuel-report/device-fuel-report.component';
// import { DeviceSOSreportComponent } from './device-report/device-sosreport/device-sosreport.component';
// import { TripByDeviceComponent } from './device-report/trip-by-device/trip-by-device.component';
// import { IdleReportComponent } from './device-report/idle-report/idle-report.component';
// import { TravelPathReportComponent } from './device-report/travel-path-report/travel-path-report.component';
// import { ExpenseComponentComponent } from './device-report/trip-by-device/expense-component/expense-component.component';
// import { ExpenselistComponent } from './device-report/trip-by-device/expenselist/expenselist.component';
// import { WorkingHourReportComponent } from './device-report/working-hour-report/working-hour-report.component';
// import { ReportFilterComponent } from './device-report/report-filter/report-filter.component';
// import { TripLoadUnloadComponent } from './device-report/trip-load-unload/trip-load-unload.component';
// import { MaintananceComponent } from './device-report/maintanance/maintanance.component';
// import { WorkingHourDetailComponent } from './device-report/working-hour-detail/working-hour-detail.component';
// import { TempretureGraphComponent } from './device-report/tempreture-graph/tempreture-graph.component';
// import { TempretureReportComponent } from './device-report/tempreture-report/tempreture-report.component';
// import { DeviceReportComponent } from './device-report/device-report.component';
// import { DailyDetailsComponent } from './device-report/daily-details/daily-details.component';

export const router: Routes =[
    { path: '', redirectTo: 'login', pathMatch: 'full' },

    { path: 'community', component: CommunityComponent },
    { path: 'rule', component: RuleComponent },
    { path: 'login', component: LoginComponent },
       { path: 'home', component: HomeComponent },
    { path: 'signup', component: SignupComponent },
    { path: 'support', component: SupportComponent },
    { path: 'gmap', component: GmapComponent },
    { path: 'dash', component: DashComponent},
    { path: 'account', component: AccountComponent},
    // {path: 'soon', component:SoonComponent},
    {path: 'details', component:DetailsComponent},
    {path: 'gateway', component:GatewayComponent},
    {path: 'const', component:ConstComponent    },
    {path: 'glocation', component:LocationComponent},
    {path: 'location', component:LocationNewComponent},
    {path : 'location/immobilize', component : ImmobilizeComponent},
    {path: 'dashboard', component:DashboardComponent},
    {path: 'dashboard/:id', component:DashboardComponent},
    {path: 'edit-sche', component:EditScheComponent},
    {path : 'device/certOptioon',component :CertOptionComponent},
    {path: 'geofencing', component:GeofencingComponent},
    {path : 'add/reset_password', component : ResetPasswordComponent},
    {path: 'geofence-add', component:GeofenceAddComponent},
    {path: 'geofencing-view', component: GeofencingViewComponent},
    {path: 'geofencing-view2', component: GeofencingView2Component},
    {path: 'add-device', component:DialogContentExampleDialogComponent},
    {path: 'dashboard/device-edit', component:DeviceEditComponent},
    
    {path: 'deealer/dealer_permission', component:DealerPermissionComponent},
    {path: 'playTrip',component:PlayTripComponent},
    
    {path : 'device/normal_cert', component : NormalCertComponent},
    {path : 'add/report_sestting',component : ReportSettingComponent},
    {path : 'add/dashboard_content', component : DashboardContentComponent},
    // {path : 'device-report/dailyLogs',component : DailyLogsComponent}, 
    {path: 'vehicleExpense',component : VehicleExpensesComponent},
    {path :'addVehicleExpense', component : AddVehicleExpensesComponent},
    {path : 'vehExpenseDetail', component : VehicleExpenseDetailComponent},
    {path: 'dashboard/device-share', component:DeviceShareComponent},
    {path : 'product-summary', component : ProductSummaryComponent},
    {path :'product-summary/add_product',component: AddProductComponent},
    {path : 'product-shop/product-overview', component : ProductOverviewComponent},
    {path: 'dashboard/share-user', component:ShareUserComponent},
    {path: 'dashboard/speednotify', component:SpeednotifyComponent},
    {path: 'location/share-loc', component:ShareLocComponent},
    {path: 'add', component:AddComponent},
    {path : 'const/shared_devices',component : SharedDevicesComponent},
    {path: 'resetpwd', component:ResetpwdComponent},
    {path: 'const/getdevdetail', component:GetdevdetailComponent},
    {path: 'sidebar', component:SidebarComponent},
    {path: 'notification', component:NotificationComponent},
    {path: 'myaccount', component:MyaccountComponent},
    {path: 'add-cust',component:AddCustComponent},
    {path: 'spec-dev', component:SpecDevComponent},
    {path: 'about-us',component:AboutUsComponent},
    {path: 'services',component:ServicesComponent},
    {path:'device-details',component:DetailsComponent},
    {path: 'location/live-history',component:LiveHistoryComponent},
    {path:'vehicle/reminder_service',component:VehicleReminderComponent},
    {path : "vehicle_reminder/add_reminder" , component:AddReminderComponent},
    {path: 'productShop' , component : ProductShopComponent},
    {path:'product-shop/buyProduct',component : BuyNowComponent},
    {path :'product-shop/BillingInfo',component : BillingInfoComponent},
    {path:"cmdWind",component:CommandWindowComponent},
    {path : 'orderSummary',component : OrderSummaryComponent},
    {path: 'orderDetail', component: OrderDetailsComponent},
    {path : 'demoVideos', component : DemoVideosComponent},
    {path: 'POI_list',component: POIreportComponent},    
    {path:'manualAddress',component : ManualAddressComponent},
    {path :'add_device', component: AddDeviceComponent},
    {path : 'CmdUIComponent',component:CmdUIComponent},
    {path : 'addreessUpdate',component:AddressUpdateComponent},
    {path: 'group_view',component: GroupComponent},
    {path: 'addgroup',component: AddGroupComponent},
    {path : 'sosalert', component: SOSAlertComponent},
    {path: 'editgrp',component: EditGroupComponent},
    {path: 'deleteGrp',component: DeleteGroupComponent},
    {path : 'commanQueue',component: CommanQueueComponent},
    {path: 'accountSettings',component: AccountDetailComponent},
    {path: 'notifSettings',component: NotificationSettingComponent},
    {path : 'PointShareComponent',component : PointShareComponent},
    {path: 'messageUtility',component : MessageUtilityComponent},
    {path: 'censor',component : CensorDisplayComponent},
    // {path : 'live',component : LiveTrackingComponent},
    {path: 'fuelComp',component: SidemenuFuelComponent},
    {path: 'vehicleRoute',component: VehicleRouteComponent},
    {path: 'setRoute',component: RouteSetComponent},
    {path: 'viewRoute',component: ShowRouteComponent},
    {path: 'dealerInfo',component: DealersInfoComponent},
    {path: 'routeMapping',component: RouteMappingComponent},
    {path: 'editrouteMap',component: EditRouteMapComponent},
    {path : 'suAdmin', component : SubAminComponent},
    {path: 'subAdmin/addSubAdmin',component:AddsubadminComponent},
    {path: 'addRouteMap',component: RouteMapAddComponent},
    {path: 'Point_Of_Intrest',component:PointOfIntrestComponent},
    {path: 'POI_master_edit',component:PoiMasterEditComponent},
    {path : 'cus_support', component : CostumerSupportComponent},
    
    {path: 'routeDelete',component:RouteDeleteComponent},
    {path: 'addDealer',component:AddDealerComponent},
    {path: 'distributersList', component : DistributersListComponent},
    {path : 'addDistributers', component : AddDistributersComponent},
    {path: 'notifications',component:NotificationMasterComponent},
    {path: 'edit-cust',component:EditCostumerComponent},   
    {path: 'edit-dealer',component:EditDealerComponent},
    {path: 'tripHistory',component:TripHistoryComponent},
    {path: 'fuelobj',component:FuelObjectcomponentComponent},
    {path: 'poiList',component:PoiListComponent},
    {path: 'loadManagement',component:LoadManagementComponent},
    {path: 'lrinput',component:LRNumberComponent},
    
    {path: 'showCaliberation',component:ShowCaliberationComponent},//----path
    {path: 'VehicleType',component:VehicleTypeComponent},
    {path: 'driverdetail',component:DriverDetailComponent},//path
    {path: 'deviceModel',component:DeviceModelComponent},//path
    {path: 'billingDashboard',component : BillingDashboardComponent},
    {path : 'generalSetting', component : GeneralSettingsComponent},
    {path: 'addEditVehicleType',component:AddEditVehicleTypeComponent},
    {path: 'addDriver',component:AddDriverComponent},
    {path: 'addDeviceModel',component:AddDeviceModelComponent},
    {path: 'poilist',component:POIdetailsComponent},
    {path: 'poimenu',component:PoiMenuComponent},
    {path: 'fuel_Report',component:FuelReportGraphComponent},
    {path: 'editVehicle_type',component:EditVehicleTypeComponent},
    {path: 'editDeviceModel',component:EditDeviceModelComponent},
    {path: 'userLogs',component:UserMasterComponent},
    {path: 'deviceMaster',component:DeviceComponent},
    {path: 'gpsMaster',component:GpsMasterComponent},
    {path: 'cmdMaster',component:CmdPacketMasterComponent},
    {path : 'deviceEntry', component : DeviceEntryComponent},
    {path : 'Inventorylist', component : InventoryListComponent},
    {path : 'RenewReport', component : DeviceRenewComponent},
    {path : 'report-schedule', component : ReportScheduleComponent},
    
    // --------------------OLD--------------------------/
    // {path: 'device-report/tripsDetails',component:TripDetailsComponent},
    // {path : 'device-report/tripexpense',component : ExpenseComponentComponent},
    // {path: 'device-report/device-speed-report', component:DeviceSpeedReportComponent},
    // {path:'daily-details',component:DailyDetailsComponent},
    // {path: 'device-report', component:DeviceReportComponent},
    // {path : 'device-report/expenseList',component : ExpenselistComponent},
    // {path: 'device-report/ideal-report', component: IdealReportComponent },
    // {path: 'device-report/ign-report', component:IgnReportComponent},
    // {path : 'device-report/idle-report', component : IdleReportComponent},
    // {path : 'workhourReport', component : WorkingHourReportComponent},
    // {path : 'work_detail', component : WorkingHourDetailComponent},
    // {path: 'device-report/devicesosReport',component:DeviceSOSreportComponent},
    // {path: 'device-report/summary-report',component:SummaryReportComponent},
    // {path: 'device-report/daywise-report',component:DayWiseReportComponent},
    {path: 'device-report/dev-fuel-report',component:DeviceFuelReportComponent},
    // {path: 'device-report/geofancing',component:GeofancingReportComponent},
    // {path: 'device-report/overspeed',component: OverSpeedComponent},
    // {path: 'device-report/routeViolation',component: RouteViolationComponent},
    // {path: 'device-report/stoppage_report',component: StoppageReportComponent},
    // {path: 'device-report/ignition_report',component: IgnitionReportComponent},
    // {path: 'device-report/distance_report',component: DistanceReportComponent},
    // {path: 'device-report/alert_report',component: AlertReportComponent},
    // {path: 'device-report/trip_report',component: TripReportComponent},
    // {path: 'device-report/POI_report',component: POIReportComponent},
    // {path: 'device-report/deviceTrip',component: TripByDeviceComponent},
    // {path: 'report_filter',component: ReportFilterComponent},    
    // {path: 'device-report/ac_report',component: AcReportComponent},
    // {path: 'device-report/tripLoadUnload',component: TripLoadUnloadComponent},
    // {path : 'device-report/travel_path' ,component : TravelPathReportComponent},
    // // {path : 'device-report/ac_report/info',component:AcreportInfoComponent},
    // {path: 'device-report/fuel_report',component: FuelReportComponent},
    {path : 'device-report/temp_report', component : TempretureReportComponent},
    // {path: 'device-report/Driver-performance',component:DriversPerformanceReportComponent},
    {path : 'device-report/tempGraph',component : TempretureGraphComponent},
    // {path: 'maintananceReport',component: MaintananceComponent},

    //--------------------------------
     {path : 'deviceList',component : DeviceListComponent},
     {path : 'toll',component : TollComponent},
     {path : 'deviceInventory',component : DeviceInventoryComponent},
     {path : 'technician',component : TechnicianComponent},
     {path : 'JobCard',component : JobCardComponent},
     {path : 'JobCardAdd',component : AddJobCardComponent},
    {
    path: 'reports',
    component: MainComponent, // this is the component with the <router-outlet> in the template
    // loadChildren: () => import('./report/report.module').then(m => m.ReportModule),
    children: [
    {
        path: 'ac_report', // child route path
        component: AcReportsComponent, 
      },
      {
        path: 'distance_report', // child route path
        component: DisatanceReportComponent, 
      },
       {
        path: 'daily_report', // child route path
        component: DailyReportComponent, 
      },
      {
        path: 'daily_logs', 
        component: DailyLogssComponent, 
      },
      {
        path: 'daywise_report', 
        component: DayWiseReportComponent, 
      },
      {
        path: 'geofence_report', 
        component: GeofancingReportComponent, 
      },
       {
        path: 'idle_report', 
        component: IdleReportComponent, 
      },
      {
        path: 'ignition_report', 
        component: IgnitionReportComponent, 
      },
      {
        path: 'loading_unloading_trip', 
        component: TripLoadUnloadComponent, 
      },
      {
        path: 'overspeed_report', 
        component: OverSpeedComponent, 
      },
      {
        path: 'poi_report', 
        component: POIReportComponent, 
      },
      {
        path: 'route_violation_report', 
        component: RouteViolationComponent, 
      },
      {
        path: 'speed_variation', 
        component: DeviceSpeedReportComponent, 
      },
      {
        path: 'summary_report', 
        component: SummaryReportComponent, 
      },
       {
        path: 'stoppage_report', 
        component: StoppageReportComponent, 
      },
      {
        path: 'sos_report', 
        component: DeviceSOSreportComponent, 
      },
       {
        path: 'trip_report', 
        component: TripReportComponent, 
      },
      {
        path: 'travel_path_report', 
        component: NewTravelPathReportComponent, 
      },
      {
        path: 'working_hours_report', 
        component: WorkingHourReportComponent, 
      },
       {
        path: 'maintanance_report', 
        component: MaintananceComponent, 
      },
       {
        path: 'notification_master', 
        component: NotificationMastersComponent, 
      },
      {
        path: 'driver_performance_report', 
        component: DriversPerformanceReportComponent, 
      },
      {
        path: 'no-report', 
        component: NoReportComponent, 
      },
      {
        path: 'start', 
        component: StartComponent, 
      },
      {
        path: 'dataPushReport', 
        component: PushDataReportComponent, 
      },
       {path:"performanceReport",component:PerformanceReportComponent},
      // AC_report','daily_report','daily_logs','dayWiseReport','distance_report','geofence_report','idle_report',
      // 'ignition_report','loadunloadTrip','over_speed','poi_report','route_violation_report','speed_variation',
      // 'summary_report','stoppage_report','device_sos_report',
      // 'trip_report','travel_path-report','working_hours_report','maintanance_report'notification_master Driver_performance
    ],
  },
  {
    path:'IEMI_Finder',component:SoonComponent
  },
   {
    path:'USER_Finder',component:UserFinderComponent
  },
  {
    path:'issueList',component:IssueListComponent
  },
  {
    path:'recharge',component:RechargeComponent
  },
  {
    path:'inactiveAdmins',component:InactiveAdminComponent
  },
  {
    path:'routePlan',component:RouteListComponent
  },
   {
    path:'addRoutePlan',component:RoutePlanComponent
  },
  {
    path:'routePlanReport',component:RoutPlanReportComponent
  },
  {
    path:'ViewVehicle',component:ShowVehiclesComponent
  },
  {path:'KycApproval',component:KycApprovalComponent},
  {path:'FuelPrice',component:FuelPriceComponent},
  {path:'addFuelPrice',component:AddFuelPriceComponent},
   {path:'RTO_Master',component:RtoMasterComponent},
  
  {path: '**', redirectTo: 'login', pathMatch: 'full'},

];

export const routes: ModuleWithProviders = RouterModule.forRoot(router);




// WEBPACK FOOTER //
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/app.router.ts